import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { initQSASaga } from '../sagas/initQSASaga';
import { submitQSASaga } from '../sagas/submitQSASaga';
import { confirmQSASaga } from '../sagas/confirmQSASaga';

export function* qualifiedSignatureApplicationSaga() {
  yield takeEvery(actionTypes.INITIALIZE, initQSASaga);
  yield takeEvery(actionTypes.SUBMIT, submitQSASaga);
  yield takeEvery(actionTypes.CONFIRM, confirmQSASaga);
}
